<template>
	<div>
		<Header :logo="`${imgPath}/static/assets/img/brand/8/logo.png`" :width="2.64" />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/brand/8/banner.png?1`" />
			<cloud />
		</div>
		<div class="brandWrap brand8" :class="{'zh-cn': lang=='zh-cn','en-us':lang == 'en-us'}">
			<div class="brandWrapModule" :class="{'zhw': lang=='zh-cn'}">
				<p :class="{'field_1 item_center': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_1"></p>
				<p :class="{'field_2 item_center': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.71rem' : '0.6rem' }" v-html="detail.field_2"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.58rem' : '1.125rem' }"><img :src="detail.field_3" width="100%" /></p>
			<div class="brandWrapModule item_center" :class="{'zhw': lang=='zh-cn'}" :style="{ 'marginTop': lang=='zh-cn'? '1.34rem' : '1.725rem' }">
				<img :src="detail.field_4" style="width: 0.95rem; display:block; margin:0 auto;" />
				<p :class="{'field_1 item_center': lang=='zh-cn', 'field_3': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.62rem' : '0.62rem' }" v-html="detail.field_5"></p>
				<p :class="{'field_2 item_center': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.69rem' : '0.62rem' }" v-html="detail.field_6"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '0.99rem' : '0.425rem' }"><img :src="detail.field_7" width="100%" /></p>
			<div class="brandWrapModule" style="padding-left:0.04rem" :style="{ 'marginTop': lang=='zh-cn'? '1.33rem' : '1.475rem' }">
				<div class="brandFlexView"><p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_9"></p><img :src="detail.field_8" style="width: 0.95rem" /></div>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" style="margin-top: 0.7rem; width:5.74rem" v-html="detail.field_10"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.03rem' : '0.775rem' }"><img :src="detail.field_11" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.26rem' : '1.525rem' }">
				<div class="brandFlexView"><p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_13"></p><img :src="detail.field_12" style="width: 0.95rem" /></div>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.76rem' : '0.62rem' }" v-html="detail.field_14"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.03rem' : '0.775rem' }"><img :src="detail.field_15" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.27rem' : '1.36rem' }">
				<div class="brandFlexView"><p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_17"></p><img :src="detail.field_16" style="width: 0.95rem" /></div>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.66rem' : '0.62rem' }" v-html="detail.field_18"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.43rem' : '1.43rem' }"><img :src="detail.field_19" width="100%" /></p>
			<div class="brandImg_style1 item_center" :style="{ 'marginTop': lang=='zh-cn'? '1.64rem' : '1.64rem' }"><img :src="detail.field_20" style="width:0.95rem; display:block; margin:0 auto;" /></div>	
			<div class="brandWrapModule item_center" :style="{ 'marginTop': lang=='zh-cn'? '0.47rem' : '0.47rem' }">
				<div :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_21"></div>
			</div>
			<p class="brandImg_style1 item_center" :style="{ 'marginTop': lang=='zh-cn'? '0.95rem' : '0.95rem' }"><img :src="detail.field_22" style="width:4.98rem" /></p>	
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1rem' : '1rem' }"><img :src="detail.field_23" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.27rem' : '1.36rem' }">
				<div class="brandFlexView"><p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_25"></p><img :src="detail.field_24" style="width: 0.95rem" /></div>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.66rem' : '0.62rem' }" v-html="detail.field_26"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '0.79rem' : '1.155rem' }"><img :src="detail.field_27" width="100%" /></p>
			<div class="brandImg_style1 newBrandView">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_28"></p>
				<div :style="{ 'marginTop': lang=='zh-cn'? '0.3rem' : '0.3rem' }"><img :src="detail.field_29" width="100%" /></div>
				<p :class="{'field_5': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.35rem' : '0.35rem' }" v-html="detail.field_30"></p>
				<div :style="{ 'marginTop': lang=='zh-cn'? '0.82rem' : '0.82rem' }"><img :src="detail.field_31" width="100%" /></div>
				<p :class="{'field_5': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.35rem' : '0.35rem' }" v-html="detail.field_32"></p>
				<div :style="{ 'marginTop': lang=='zh-cn'? '0.82rem' : '0.82rem' }"><img :src="detail.field_33" width="100%" /></div>
				<p :class="{'field_5': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.35rem' : '0.35rem' }" v-html="detail.field_34"></p>
			</div>
			
			<a class="brandLinkWrap black" :href="detail.field_36" target="_blank">
				<p class="brandLink1">{{detail.field_37}}</p>
				<p class="brandLink2">{{detail.field_35}}</p>
				<img class="linkIcon" :src="`${imgPath}/static/assets/img/brand/linkImg1.png`" />
			</a>
			<top />
			<div class="cloudImg">
				<img :src="`${imgPath}/static/assets/img/cloud.png`" />
			</div>
			<bottom />
		</div>
	</div>
</template>
<script>
export default {
    data(){
		return{
			detail:{},
			lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
		}
	},
	async mounted() {
		let res = await this.$util.getBrandDetail(22)
		this.detail = res;
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/brandStyle.scss";
</style>


// WEBPACK FOOTER //
// src/views/brand/brand6.vue